import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import Application from './Application';
import { Auth0Context } from './context/Auth0Context';
import FeatureProvider from './FeatureProvider';
import { store } from './redux/store';
import { pricerTheme } from './theme';
export var AppRoot = function () {
    return (_jsxs(ThemeProvider, { theme: responsiveFontSizes(createTheme(pricerTheme)), children: [_jsx(CssBaseline, {}), _jsx(Provider, { store: store, children: _jsx(FeatureProvider, { children: _jsx(BrowserRouter, { children: _jsx(Auth0Context, { children: _jsx(Application, {}) }) }) }) })] }));
};
